import {AfterViewInit, Component, ElementRef, Input, OnInit, QueryList, ViewChild, ViewChildren} from '@angular/core';
import {ExcCoreModule, ExcTranslation} from 'exc-core-v2';
import {ExgDataListComponent, ExgModalService, ExgSearchBarComponent} from 'exc-controls-v2';
import {EnumerationService} from '../../services/enumeration.service';

@Component({
  selector: 'app-modal-enum-multiple-choice',
  templateUrl: './modal-enum-multiple-choice.component.html',
  styles: [
  ]
})
export class ModalEnumMultipleChoiceComponent extends ExcTranslation implements OnInit, AfterViewInit {
  @ViewChild('searchBar', {read: ExgSearchBarComponent})  searchBar!: ExgSearchBarComponent;
  @ViewChildren('listRow', { read: ElementRef }) listRows!: QueryList<ElementRef>;
  @Input()  data: any;
  enmName: any = '';
  chosenEnumIdentArray: any[] = [];
  enmObjectList = [] as any[];
  searchValue = '';
  countTrue = 0;

  constructor(
    private modal: ExgModalService,
    public enumSvc: EnumerationService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.initialize();
    this.initEnumeration();
  }
  ngAfterViewInit(): void {
    this.searchBar.setFocus();
  }

  initialize(): void {
    if (this.data?.enmName?.length > 0) {
      this.enmName = this.data.enmName;
    }
    if (this.data?.chosenEnumIdentArray?.length > 0) {
      this.chosenEnumIdentArray = this.data.chosenEnumIdentArray;
    }
  }

  initEnumeration(): void {
    this.enumSvc
      .getEnumerationList(this.enmName)
      .forEach((enm: any) => {
        const obj = {
          enmValue: this.chosenEnumIdentArray.includes(enm.enmIdent),
          enmText: enm.enmText,
          uiTooltip: enm.uiTooltip,
          enmTextA: enm.enmTextA,
          enmIdent: enm.enmIdent,
        };
        this.enmObjectList.push(obj);
      });
  }

  getEnmObjectList(): any[] {
    if (!this.enmObjectList) {
      return [];
    }
    this.countTrue = ExcCoreModule.Array.GetAll(this.enmObjectList, 'enmValue', true).length;
    return this.enmObjectList
      .filter(
        // Suchtext in den OEs
        enmObj => this.searchValue === ''
          || JSON.stringify(enmObj).toLowerCase().indexOf(this.searchValue.toLowerCase()) > -1
      );
  }

  search(value: string): void {
    this.searchValue = value;
  }

  cancel(): void {
    this.modal.close();
  }

  save(): void {
    this.modal.action({enmObjList: ExcCoreModule.Array.GetAll(this.enmObjectList, 'enmValue', true)
        .map((objElement: any) => {
          return {
            enmIdent: objElement.enmIdent,
            enmText: objElement.enmText
          };
        })
    });
  }

  toggleSwitchValue(enm: any): void {
    enm.enmValue = !enm.enmValue;
  }


  onArrowUp(event: any, index: number): void {
    event.preventDefault(); // Verhindert das Scrollen der Seite
    if (index > 0) {
      this.listRows.toArray()[index - 1].nativeElement.focus();
    }
    if (index === 0) {
      this.searchBar.setFocus();
    }
  }

  onArrowDown(event: any, index: number): void {
    event.preventDefault(); // Verhindert das Scrollen der Seite
    if (index < this.listRows.length - 1) {
      this.listRows.toArray()[index + 1].nativeElement.focus();
    }
  }
}
